import React from "react";
import { Facebook, Instagram, Linkedin } from "lucide-react";

export const SOCIALS = [
  {
    key: "facebook",
    label: "Facebook",
    url: "https://www.facebook.com/share/1HduiHZSAA/?mibextid=wwXIfr",
    Icon: Facebook,
  },
  {
    key: "instagram",
    label: "Instagram",
    url: "https://www.instagram.com/ct3f_ct3frontieres",
    Icon: Instagram,
  },
  {
    key: "linkedin",
    label: "LinkedIn",
    url: "https://www.linkedin.com/company/ct3f/",
    Icon: Linkedin,
  },
];

export const SocialRow = ({ size = 16, variant = "muted", testidPrefix = "social" }) => {
  // variant: 'muted' (dark surfaces) or 'amber' (info panel)
  const base =
    variant === "amber"
      ? "border border-ct3f-orange/40 text-ct3f-amber hover:bg-flame hover:text-white hover:border-transparent"
      : "border border-white/15 text-white/70 hover:text-white hover:border-white/40";
  return (
    <div className="flex items-center gap-2">
      {SOCIALS.map(({ key, label, url, Icon }) => (
        <a
          key={key}
          href={url}
          target="_blank"
          rel="noreferrer noopener"
          aria-label={label}
          data-testid={`${testidPrefix}-${key}`}
          data-umami-event="social-click"
          data-umami-event-network={key}
          className={`inline-flex items-center justify-center w-10 h-10 transition-colors ${base}`}
        >
          <Icon size={size} strokeWidth={1.6} />
        </a>
      ))}
    </div>
  );
};

export default SocialRow;
